import { User } from '@graphics/gfx-common/dist/types'
import {
  FileMalwareScan,
  EditionType,
} from '@graphics/gfx-common/dist/constants'
import { IInitAction } from './init'
import { IOption } from './common'

// Action types
export enum types {
  CREATE_DATAFILE__STARTED = 'CREATE_DATAFILE__STARTED',
  CREATE_DATAFILE__SUCCESS = 'CREATE_DATAFILE__SUCCESS',
  CREATE_DATAFILE__FAILURE = 'CREATE_DATAFILE__FAILURE',
  GET_DATAFILE__STARTED = 'GET_DATAFILE__STARTED',
  GET_DATAFILE__SUCCESS = 'GET_DATAFILE__SUCCESS',
  GET_DATAFILE__FAILURE = 'GET_DATAFILE__FAILURE',
  UPDATE_DATAFILE__STARTED = 'UPDATE_DATAFILE__STARTED',
  UPDATE_DATAFILE__SUCCESS = 'UPDATE_DATAFILE__SUCCESS',
  UPDATE_DATAFILE__FAILURE = 'UPDATE_DATAFILE__FAILURE',
}

export interface ICreateDatafileAction {
  type: types.CREATE_DATAFILE__STARTED
  packId: string
  datastream: IDataStream
}

export interface ICreateDatafileSuccessAction {
  type: types.CREATE_DATAFILE__SUCCESS
  message: string
}

export interface IFailureAction {
  type: types.CREATE_DATAFILE__FAILURE | types.UPDATE_DATAFILE__FAILURE
  message: string
  correlationId: string
}

export interface IGetDataFileFailureAction {
  type: types.GET_DATAFILE__FAILURE
  dataStreamError: string
}

export interface IGetDataFileAction {
  type: types.GET_DATAFILE__STARTED
  datastream: DataStreamForPreviewType
}

export interface IGetDataFileSuccessAction {
  type: types.GET_DATAFILE__SUCCESS
  datastream: DataStreamForPreviewType
}

export interface IUpdateDatafileAction {
  type: types.UPDATE_DATAFILE__STARTED
  packId: string
  editionId: string
  datastream: IDataStream
}

export interface IUpdateDatafileSuccessAction {
  type: types.UPDATE_DATAFILE__SUCCESS
  message: string
}

export type DatafileActionsType =
  | ICreateDatafileAction
  | ICreateDatafileSuccessAction
  | IGetDataFileAction
  | IGetDataFileSuccessAction
  | IFailureAction
  | IGetDataFileFailureAction
  | IUpdateDatafileAction
  | IUpdateDatafileSuccessAction
  | IInitAction

// Reducer types
export interface IDatafile {
  isLoading: boolean
  datastream?: DataStreamForPreviewType
  dataStreamError?: string
}

export interface IDataType {
  value: string
  returnName: boolean
}

export interface IDataStreamRequest {
  instrument: string
  kind: string
  frequency: string
  start: string
  end: string
  dataTypes: IDataType[]
  isExpression: boolean
  isList: boolean
  isSymbolSet: boolean
  returnName: boolean
  returnCurrency: boolean
  returnNoDates: boolean
}

export interface IDataStreamData {
  fileName: string
  requests: IDataStreamRequest[]
}

export interface IDataStream {
  id?: string
  editionType: EditionType
  title: string
  dataStreamData: IDataStreamData
  created?: string
  createdBy?: User
  modified?: string
  modifiedBy?: User
}

interface IDataRequestForPreview {
  DataTypes: any
  Date: {
    End: string | null
    Frequency: string | null
    Kind: number
    Start: string | null
  }
  Instrument: {
    Properties: Array<{
      Key?: string
      value: boolean
    }> | null
    Value: string | null
  }
  Tag?: any
}

export interface ISingleDataStreamForPreviewRequest {
  DataRequest: IDataRequestForPreview
  Properties?: any
}

export interface IMultipleDataStreamForPreviewRequest {
  DataRequests: IDataRequestForPreview[]
  Properties?: any
}

export type DataStreamForPreviewType =
  | ISingleDataStreamForPreviewRequest
  | IMultipleDataStreamForPreviewRequest

export type IDataStreamError = string

// Service types
export interface IDatafileFormInputs {
  title: string
  fileName: string
  requests: IDataStreamRequest[]
  [x: string]: any
}

export interface IMalwareScanResponse {
  fileId: string
  malwareScan: FileMalwareScan
  malwareScanDate: string
  location?: string
  downloadURI?: string
}

export interface ICaptionOption extends IOption {
  isCaption?: boolean
}
